import React, { createContext, useState, useEffect } from 'react';
import { logoutStateReset } from '../redux/slices/auth/LogoutSlice';
import { loginStateReset } from '../redux/slices/auth/LoginSlice';
import { useDispatch, useSelector } from 'react-redux';
import { GetProfileApi } from '../redux/actions/profile/GetProfileAction';
import Swal from 'sweetalert2';
export const AuthContext = createContext();

// AuthProvider component that provides authentication-related functions to children components
export const AuthProvider = ({ children }) => {
    const dispatch = useDispatch();
    const { response: profileResponse, loading: profileLoading, error: profileError } = useSelector((state) => state.profile)
    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        const token = localStorage.getItem('authToken');
        return token ? true : false;
    });


    // Function to log in the user and store the auth token in localStorage
    const login = (token) => {
        localStorage.setItem('authToken', token);
        setIsAuthenticated(true);
    };

    const logout = () => {
        localStorage.removeItem('authToken');
        setIsAuthenticated(false);
        Swal.fire({
            title: 'Logged out!',
            text: 'You have been successfully logged out.',
            icon: 'success',
            confirmButtonColor: '#49a496'
        }
        );
        dispatch(logoutStateReset());
        dispatch(loginStateReset());
    };

    // Function to fetch the user's profile from the API
    const fetchProfile = async () => {
        try {
            await dispatch(GetProfileApi());
        } catch (error) {
            console.error("Failed to fetch profile:", error);
        }
    };

      useEffect(() => {
        if (isAuthenticated) {
            fetchProfile();
        }
    }, [isAuthenticated]);




    useEffect(() => {
        const checkAuth = () => {
            const token = localStorage.getItem('authToken');
            if (token) {
                setIsAuthenticated(true)
            } else {
                setIsAuthenticated(false)
            }
        };
        checkAuth();
    }, []); 

    return (
        <AuthContext.Provider value={{ isAuthenticated, login, logout, fetchProfile }}>
            {children}
        </AuthContext.Provider>
    );
};
